import { v4 as uuidv4 } from 'uuid';
import { ParameterNodeBuilder } from '../../builder/ParameterNodeBuilder';
import { CLONE_METHOD_NAME, cloneDeep } from '../../utils';
import { Type } from '../Type';
export class ParameterList extends Array {
    type = Type.List;
    logicalType;
    tags;
    constructor(values = [], logicalType, tags) {
        super(...values);
        this.logicalType = logicalType;
        this.tags = tags;
    }
    [CLONE_METHOD_NAME]() {
        return new ParameterList(this.map(cloneDeep), cloneDeep(this.logicalType), cloneDeep(this.tags));
    }
    static get [Symbol.species]() {
        return Array;
    }
    static new() {
        return new ParameterListBuilder();
    }
}
class ParameterListBuilder {
    items = [];
    addValue(key, value, build) {
        const builder = ParameterNodeBuilder.fromValue(uuidv4(), key, value);
        if (build)
            build(builder);
        const node = builder.build();
        this.items.push(node);
        return this;
    }
    addValues(values, build) {
        for (const [key, value] of values) {
            this.addValue(key, value, build);
        }
        return this;
    }
    build() {
        return new ParameterList(this.items);
    }
}
//# sourceMappingURL=data:application/json;base64,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